// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__XepUa","navLink":"NavBar_navLink__6FxQj","navbar-toggler":"NavBar_navbar-toggler__t5edx","navMenu":"NavBar_navMenu__V6Rpv","active":"NavBar_active__QwDlZ"};